import React, {useState, useEffect} from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import CustomButton from "../../../components/ui/CustomButton";
import axios from "axios";
import {setState} from "../../../store/loginSlice";
import { useSelector, useDispatch } from "react-redux";

const baseApiUrl = process.env.REACT_APP_API_URL;

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
export const SignInButton = () => {
	const { instance } = useMsal();
	const {response1, setResponse} = useState(null);
	const dispatch = useDispatch();
	// const handleLogin = (loginType) => {
	// 	if (loginType === "popup") {
	// 		instance.loginPopup(loginRequest).catch((e) => {
	// 			console.log(e);
	// 		});
	// 	} else if (loginType === "redirect") {
	// 		instance.loginRedirect(loginRequest).catch((e) => {
	// 			console.log(e);
	// 		});
	// 	}
	// };
	const GetUserDetails = (username) => {
		const baseUrl =
		baseApiUrl+`SSOLogin?email=`+username;
		axios
		  .get(baseUrl, {
		  })
		  .then((response) => {
			if( response !== undefined && response !== null &&response?.data !== 'not exist'){
				let uri4 = JSON.stringify(response?.data);
				let obj4 = {
					type: "Info",
					info: "Login error:",
					jsonlist: uri4,
				};
				Logging(obj4);
			  //if(email !== response?.data?.email){
				localStorage.setItem("data", JSON.stringify(response?.data));
				window.location.replace(window.location.origin+'/dashboard');
				dispatch(setState("isLoggedIn", true));
			  //}
			}
		  });
	  };

	  const Logging = async (obj) => {
		try {
		   // Make the POST request
		   let url = baseApiUrl + "Home/Logging";
		   const response = await fetch(url, {
			  method: "POST",
			  headers: {
				 "Content-Type": "application/json",
			  },
			  body: JSON.stringify(obj),
		   });
	 
		   // Parse the response
		   const result = await response.json();
	 
		   // Set the response in the state
		} catch (error) {
		   console.error("Error making POST request:", error);
		}
	 };
	 

	const handleLogin = async () => {
		try {
		  const response = await instance.loginPopup(loginRequest); // You can use loginRedirect instead
		 // console.log("Access Token:", response.accessToken);
		  let uri1 = JSON.stringify(response.accessToken);
			let obj1 = {
				type: "Info",
				info: "Access Token:",
				jsonlist: uri1,
			};
			Logging(obj1);
		  const account = response.account;
		  let uri2 = JSON.stringify(response.account);
		  let obj2 = {
			  type: "Info",
			  info: "account:",
			  jsonlist: uri2,
		  };
		  Logging(obj2);
		  console.log("Email ID:", account.username);
		  GetUserDetails(account.username);
		} catch (error) {
		  console.error("Login error:", error);
		  let uri3 = JSON.stringify(error);
		  let obj3 = {
			  type: "Info",
			  info: "Login error:",
			  jsonlist: uri3,
		  };
		  Logging(obj3);
		}
	  };


	return (
		// <DropdownButton variant="secondary" className="ml-auto" drop="start" title="Sign In">
		//     <Dropdown.Item as="button" onClick={() => handleLogin("popup")}>Sign in using Popup</Dropdown.Item>
		//     <Dropdown.Item as="button" onClick={() => handleLogin("redirect")}>Sign in using Redirect</Dropdown.Item>
		// </DropdownButton>
		<>
			<CustomButton onClick={() => handleLogin("popup")}>
				Login with Azure AD
			</CustomButton>
			{/* <CustomButton onClick={() => handleLogin("redirect")}>
				Sign in using Redirect
			</CustomButton> */}
		</>
	);
};
